<template>
  <div>
    <div class="topbar">
      <i @click="goHome"></i>
      <!-- <span>{{$t('nav_name')}}</span> -->
      <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item,index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >{{item.name}}</li>
          </ul>
        </div>
        <div class="settingBtn" @click.stop="setting()">
          {{$t("myaccount_title")}}
          <em class="iconfont icon-een"></em>
          <ul v-show="settingBoxVis" class="chooseLangUl chooseLangUls">
            <li @click="toMyAccount">{{$t("myHome")}}</li>
            <li @click="race">{{$t("myPageTitle")}}</li>
            <li @click="logOut">{{$t("setting_2")}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="forget">
        <div class="forgetPsd">{{$t('invite_title')}}</div>
        <!-- <span class="line"></span>  -->
        <div class="leftContainer">
          <img src="~@/assets/images/icode_invite_introduce.png" />
        </div>
      </div>
    </div>
     <LeapPopup v-show="maskBox" @onOK="logOut"
      :title="$t('timeout01')" :content="$t('timeout02')" 
      :cancelButtonTxt="$t('timeout04')"
      :okButtonTxt="$t('timeout03')"
      :isConfirm="false"></LeapPopup>
  </div>
</template>

<script>
import store from "../store";
import { mapGetters } from "vuex";
import LeapPopup from "./LeapPopup";
import Vue from 'vue'
Vue.component("LeapPopup",LeapPopup);
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: "myAccount",
  data() {
    return {
      changeLangBox: false,
      langList: I18nUtils.langList,
      settingBoxVis: false
    };
  },
  mounted() {
    I18nUtils.initLanguage(this);
  },
  watch: {},
  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },
    
    toMyAccount() {
      this.$router.push({ path: "/myAccount" });
    },
    goHome() {
      this.$router.push({ path: "/index" });
    },
    setting() {
      this.settingBoxVis = !this.settingBoxVis;
      this.changeLangBox = false;
    },
    race() {
      this.$router.push({ path: "/myPage" });
    },
    
    logOut() {
      this.$http
        .getAxios("/user/logout", {
          method: "post"
        })
        .then(res => {
          var res = res.data;
          if (res.code == "0") {
            this.channel.clear();//清空数据
            store.commit("toggleMaskState",false);
            this.$router.push({ path: "/" });
          }
        });
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
    },

  },
  computed:{
    ...mapGetters(['maskBox','name']),
    lan(){
      return this.$i18n.locale
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">

.topbar {
  width: 100%;
  height: 60px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 8px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 99999999999999999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
}
.topbar span {
  font-size: 20px;
  line-height: 60px;
  margin-left: 100px;
}
.banner {
  width: 1200px;
  margin: 0 auto;
  .forget {
    height: 400px;
    position: absolute;
    /*top:35%;*/
    margin-top: 160px;
    top: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .forgetPsd {
    margin-left: 15px;
    width: 453px;
    height: 58px;
    background: url("~@/assets/images/title.png") no-repeat center;
    font-size: 38px;
    font-weight: 700;
    line-height: 58px;
    color: #37c2e5;
  }
}
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  line-height: 60px;
}
.changeLangBtn1 {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  line-height: 60px;
  margin-right: 20px;
}
.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}
.chooseLangUls {
  width: 100%;
  background: #0c355c;
  padding: 0 5px 10px 5px;
  border-radius: 5px;
}
.settingBtn,
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}
.settingBtn {
  padding-right: 0px;
  margin-right: 20px;
  line-height: 60px;
  text-align: center;
  position: relative;
  min-width: 150px;
}
.mainBox1 {
  height: 60px;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 323223;
}
.leftContainer{
  float: left;
  width: 51%;
}
</style>




// WEBPACK FOOTER //
// src/components/invite.vue